import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) bottom/ cover no-repeat`}
          column
          justifyStart
          alignCenter
          textCenter
        >
          <Header />
          <CFImage
            mt="20px"
            w="100%"
            src={mobileHeroText}
            alt="Miraku Sushi hero text"
            zIndex={98}
          />
          <CFView pulsate mt="15px">
            <OrderPickupButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <Header />
        <CFView
          h="95vh"
          maxHeight="670px"
          w="100%"
          image={`url(${hero}) 45% 0 / cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          <CFView column center ml="3%">
            <CFImage
              w="40vw"
              minWidth="500px"
              maxWidth="600px"
              src={heroText}
              alt="Miraku Sushi hero text"
              zIndex={98}
            />
            <CFView pulsate mt="25px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
